import {
  DiscrepancyStatus,
  InterestStatus as ServerInterestStatus,
  PenaltyStatus as ServerPenaltyStatus,
  ReportingStatus as ServerReportingStatus,
} from '../../api/ariadne/__generated_types__/graphql';
import {
  Auditing,
  QueryFilters,
  TopLevelTOTFilters,
  Interest as UIInterestStatus,
  Penalties as UIPenaltiesStatus,
  ReportingStatus as UIReportingStatus,
} from '../types';

function uiReportingStatusToServer(
  value: UIReportingStatus
): ServerReportingStatus {
  return {
    REPORTED: ServerReportingStatus.Reported,
    UNREPORTED: ServerReportingStatus.Unreported,
  }[value];
}

function uiInterestToServer(value: UIInterestStatus): ServerInterestStatus {
  return {
    HAS_INTEREST: ServerInterestStatus.HasInterest,
    NO_INTEREST: ServerInterestStatus.NoInterest,
  }[value];
}

function uiPenaltiesToServer(value: UIPenaltiesStatus): ServerPenaltyStatus {
  return {
    HAS_PENALTY: ServerPenaltyStatus.HasPenalty,
    NO_PENALTY: ServerPenaltyStatus.NoPenalty,
  }[value];
}

function uiAuditingToServer(value: Auditing) {
  return {
    POTENTIAL_TAX_DISCREPANCY: DiscrepancyStatus.HasUninvestigatedDiscrepancy,
  }[value];
}

export function uiFiltersToServerFilters(
  filters: TopLevelTOTFilters
): QueryFilters {
  return {
    reportingStatus: filters.reportingStatus.map(uiReportingStatusToServer),
    interest: filters.interest.map(uiInterestToServer),
    penalties: filters.penalties.map(uiPenaltiesToServer),
    discrepancy: (filters.auditing ?? []).map(uiAuditingToServer),
    removeZeroTaxableReceipts: filters.removeZeroTaxableReceipts,
  };
}
